import React, { useState } from 'react';
import { ArrowClockwise, CheckCircle, DownloadSimple } from '@phosphor-icons/react';
import { useAppUpdate, shortVersion } from '../hooks/useAppUpdate';

// Point 3 — Settings section (admin/handler) to see the running version and
// manually check / apply an update.
export const AppVersionCard = () => {
  const { current, latest, updateAvailable, checking, check, applyUpdate } = useAppUpdate(true);
  const [checkedOnce, setCheckedOnce] = useState(false);
  const [applying, setApplying] = useState(false);

  const onCheck = async () => {
    await check();
    setCheckedOnce(true);
  };
  const onUpdate = async () => {
    setApplying(true);
    await applyUpdate();
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4" data-testid="app-version-card">
      <div className="flex items-center gap-2 mb-1">
        <DownloadSimple size={20} weight="bold" className="text-slate-700" />
        <h3 className="font-bold text-base text-slate-800">App Version</h3>
      </div>
      <p className="text-[12px] text-slate-500 mb-3">
        Running version and update status for this device.
      </p>

      <div className="flex items-center justify-between bg-slate-50 rounded-xl px-3 py-2 mb-3">
        <span className="text-[12px] text-slate-500">Current version</span>
        <span className="font-mono text-[12px] font-bold text-slate-800" data-testid="app-version-current">
          {shortVersion(current)}
        </span>
      </div>

      {updateAvailable ? (
        <div className="flex items-center gap-2 text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-xl px-3 py-2 mb-3">
          <ArrowClockwise size={16} weight="bold" />
          <span className="text-[12px] font-semibold">
            New version available{latest ? ` (${shortVersion(latest)})` : ''}
          </span>
        </div>
      ) : (
        checkedOnce && (
          <div className="flex items-center gap-2 text-slate-600 bg-slate-50 rounded-xl px-3 py-2 mb-3">
            <CheckCircle size={16} weight="fill" className="text-emerald-500" />
            <span className="text-[12px] font-semibold">You are on the latest version</span>
          </div>
        )
      )}

      <div className="flex gap-2">
        <button
          onClick={onCheck}
          disabled={checking || applying}
          data-testid="app-version-check-btn"
          className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-50 disabled:opacity-60"
        >
          <ArrowClockwise size={15} weight="bold" className={checking ? 'animate-spin' : ''} />
          {checking ? 'Checking…' : 'Check for updates'}
        </button>
        {updateAvailable && (
          <button
            onClick={onUpdate}
            disabled={applying}
            data-testid="app-version-update-btn"
            className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold disabled:opacity-60"
          >
            <DownloadSimple size={15} weight="bold" />
            {applying ? 'Updating…' : 'Update now'}
          </button>
        )}
      </div>
    </div>
  );
};

export default AppVersionCard;
